import { render, staticRenderFns } from "./ScoringInput.vue?vue&type=template&id=6ab12c56"
import script from "./ScoringInput.vue?vue&type=script&lang=js"
export * from "./ScoringInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports